export default [
    {
        week: 1,
        day: 1,
        type: 'stars',
        status: {
            'de': 'Überraschung: Sterne für dich!',
            'en': 'Surprise: Stars for you!'
        }
    },
    {
        week: 1,
        day: 2,
        type: 'text',
        status: {
            'de': 'Überraschung: Hast du das gewusst?',
            'en': 'Surprise: DId you know?'
        },
        content: {
            'de': 'Auf dem Mars fühlen wir uns wie ein Fliegengewicht.\n\nDer Mars hat viel weniger Masse als unsere Erde. Deshalb werden wir vom Mars nicht so stark angezogen wie von der Erde. Wir könnten uns dort also federleicht fühlen. Zum Beispiel würde sich jemand mit 75 Kilogramm Masse auf dem Mars fühlen, als hätte er nur 28 Kilogramm. Nur hinreisen und ausprobieren ist derzeit noch nicht möglich.',
            'en': 'On Mars, we feel like a flyweight.\n\nMars has much less mass than our Earth. That is why we are not as strongly attracted to Mars as we are to Earth. We could therefore feel as light as a feather there. For example, someone with 75 kilograms of mass on Mars would feel as if they only had 28 kilograms. But traveling there and trying it out is not yet possible.'
        }
    },
    {
        week: 1,
        day: 3,
        type: 'text',
        status: {
            'de': 'Überraschung: Inspirierende Chemikerin!',
            'en': 'Surprise: Inspiring Chemist'
        },
        title: {
            'de': 'Katrin Schuhen,\nChemikerin',
            'en': 'Katrin Schuhen,\nChemist'
        },
        content: {
            'de': 'Katrin Schuhen war Juniorprofessorin an der Universität Koblenz-Landau und hat mittlerweile ein eigenes Unternehmen gegründet. Ihr Vorhaben, verschmutztes Wasser von Mikroplastik zu befreien, wurde von vielen ihrer Kolleginnen und Kollegen angezweifelt. Gerade diese Herausforderung spornte sie umso mehr an, das Problem zu lösen. Sie entwickelte einen Zusatzstoff, der verschmutztes Wasser wieder reinigt. Damit ist es möglich, Mikroverunreinigungen aus dem Wasser zu entfernen, bevor sie unsere Umwelt verschmutzen oder in den menschlichen Körper gelangen. Sie arbeitet mit ihrem Team an weiteren Lösungen für sauberes Wasser ohne Mikroplastik und Mikroschadstoffe.',
            'en': 'Katrin Schuhen was a junior professor at the University of Koblenz-Landau and has since founded her own company. Her project to rid polluted water of microplastics was doubted by many of her colleagues. It was this challenge that spurred her on all the more to solve the problem. She developed an additive that cleans polluted water again. This makes it possible to remove micropollutants from water before they pollute our environment or enter the human body. She is working with her company on further solutions for clean water without microplastics and micropollutants.'
        },
        copyright: {
            'de': 'Bild: Katrin Schuhen',
            'en': 'Bild: Katrin Schuhen'
        }
    },
    {
        week: 1,
        day: 4,
        type: 'stars',
        status: {
            'de': 'Überraschung: Sterne für dich!',
            'en': 'Surprise: Stars for you!'
        }
    },
    {
        week: 1,
        day: 5,
        type: 'text',
        status: {
            'de': 'Überraschung: Hast du das gewusst?',
            'en': 'Surprise: Did you know?'
        },
        content: {
            'de': 'Mit den fünf Sinnen stellt das Gehirn fest, was draußen in der Welt geschieht. Die fünf Sinne sind das Sehen, Hören, Riechen, Tasten und Schmecken.\n\nDie Sinneseindrücke werden im Gehirn in Gedanken und Gefühle umgewandelt.\n\nWer etwas nur hört oder sieht, vergisst schneller. Studien zeigen: Nichts ist so effektiv wie selber ausprobieren. So bleiben Tätigkeiten besser im Gehirn gespeichert.',
            'en': 'With our five senses the brain can detect what is going on outside in the world. The five senses are sight, hearing, touch, smell and taste.\n\n Senses are being transfered into thoughts and emotions in the brain.\n\n When only seeing or hearing something, you forget it easily. Studies show: Nothing is as effective as trying it out yourself. Actions can be better memorized by the brain.'
        }
    },
    {
        week: 2,
        day: 1,
        type: 'stars',
        status: {
            'de': 'Überraschung: Sterne für dich!',
            'en': 'Surprise: Stars for you!'
        }
    },
    {
        week: 2,
        day: 2,
        type: 'text',
        status: {
            'de': 'Überraschung: Hast du das gewusst?',
            'en': 'Surprise: Did you know?'
        },
        content: {
            'de': 'Das Gehirn eines erwachsenen Mannes wiegt durchschnittlich 1375 Gramm, das einer Frau 1245 Gramm.\n\nDer geringe Gewichtsunterschied hat keinerlei Auswirkung auf die Intelligenz.\n\nDas Frauengehirn bringt die gleiche Leistung bei weniger Gewicht – das nennt man Effizienz.',
            'en': 'The brain of a grown man has 1375 gram, and 1245 gram for women.\n\n The small difference in weight has no effect on the intelligence. \n\n The female brain performes the same with a smaller weight - this is called efficiency.'
        }
    },
    {
        week: 2,
        day: 3,
        type: 'stars',
        status: {
            'de': 'Überraschung: Sterne für dich!',
            'en': 'Surprise: Stars for you!'
        }
    },
    {
        week: 2,
        day: 4,
        type: 'text',
        status: {
            'de': 'Überraschung: Inspirierende Physikerin!',
            'en': 'Surprise: Inspiring physicist!'
        },
        title: {
            'de': 'Shirley Ann Jackson,\nPhysikerin',
            'en': 'Shirley Ann Jackson,\nPhysicist'
        },
        content: {
            'de': 'Als Shirley 1964 mit ihrem Studium begann, waren nur 43 der 900 Studienanfängerinnen und Studienanfänger Frauen und unter den 8.000 Studierenden waren etwa 20 Schwarze. Als Antwort auf den Rat eines Professors, dass „farbige Mädchen“ besser ein Handwerk erlernen sollten, entschied sie sich für Physik als Studienfach, in dem sie sehr erfolgreich werden sollte. Sie schrieb über 100 wissenschaftliche Studien zur Quantenphysik und war Beraterin der beiden amerikanischen Präsidenten Bill Clinton und Barack Obama.',
            'en': 'When Shirly began her studies in 1964, only 43 of the 900 freshmen were women, and among the 8000 students, about 20 were black. In response to a professor\'s advice that "colored girls" would be better off learning a trade, she chose physics as her field of study, in which she would become very successful. She wrote over 100 scientific studies on quantum physics and was an advisor to both American presidents Bill Clinton and Barack Obama.'
        },
        copyright: {
            'de': 'Bild: Von Shirley_Ann_Jackson_-_Annual_Meeting_of_the_New_Champions_Tianjin_2010.jpg, https://commons.wikimedia.org/w/index.php?curid=15230893',
            'en': 'Image: Shirley_Ann_Jackson_-_Annual_Meeting_of_the_New_Champions_Tianjin_2010.jpg, https://commons.wikimedia.org/w/index.php?curid=15230893'
        }
    },
    {
        week: 2,
        day: 5,
        type: 'text',
        status: {
            'de': 'Überraschung: Inspirierender Wissenschafter!',
            'en': 'Surprise: Inspiring scientist!'
        },
        title: {
            'de': 'Matthias Scheutz,\nWissenschafter und Mitglied im österreichischen Rat für Robotik',
            'en': 'Matthias Scheutz,\nScientist and member of the austrian counsil for robots'
        },
        content: {
            'de': 'Den Kognitionswissenschafter Matthias Scheutz zog es nach seinem Studium der Philosophie und technischen Informatik in Wien an die US-amerikanische Indiana University.\n\nEr erforscht und programmiert Roboter. So untersucht er wie man sich mit Robotern unterhalten kann und wie frei Roboter etwas selbst entscheiden dürfen.\n\nEine seiner Hauptfragen, die er untersucht: „Dürfen Roboter ,Nein‘ sagen wenn ein Mensch ihnen etwas befiehlt?“',
            'en': 'The cognition scientist Matthias Scheutz was drawn to research at the US University of Indiana after his studies of philosophy and coputer science in Vienna. He was researching and programming robots. Doing so he explored how you can talk with robots and wether robots should have to possibility to make decisions freely.\n\n One of his main research topics: "Are robots allowed to say no if a human tells them to do something."'
        }
    },
    {
        week: 3,
        day: 1,
        type: 'stars',
        status: {
            'de': 'Überraschung: Sterne für dich!',
            'en': 'Surprise: Stars for you!'
        }
    },
    {
        week: 3,
        day: 2,
        type: 'text',
        status: {
            'de': 'Überraschung: Hast du das gewusst?',
            'en': 'Surprise: Did you know!'
        },
        content: {
            'de': 'Es heißt zwar Schrecksekunde, der Mensch reagiert aber deutlich schneller bei Schmerz oder Gefahr.\n\nManche Impulse erreichen im Nervensystem Geschwindigkeiten von bis zu 400 Kilometern pro Stunde. Das ist schneller als ein Formel-1-Rennwagen!',
            'en': 'It is called moment of shock, but the human reaction is significantly faster than that when processing pain or danger.\n\n Some stimuli reach up to 400 kilometers per hour in the nervous system. That is faster than a Formula-Una racing car!'
        }
    },
    {
        week: 3,
        day: 3,
        type: 'text',
        status: {
            'de': 'Überraschung: Hast du das gewusst?',
            'en': 'Surprise: Did you know!'
        },
        content: {
            'de': 'Der Merkur ist mit einem Durchmesser von knapp 4880 Kilometern der kleinste Planet in unserem Sonnensystem.\n\nEr ist auch nicht so flott unterwegs wie wir: Auf dem Merkur dauert ein Tag – also eine Umdrehung um die eigene Achse – 59 Erdtage.',
            'en': 'Mercury is with a diameter of 4880 kilometers the smallest planet of our solar system.\n\nHe is also not as fast as we are: a day on mercury - that is one trun around its own axis - takes 59 days on earth.'
        }
    },
    {
        week: 3,
        day: 4,
        type: 'text',
        status: {
            'de': 'Überraschung: Inspirierende Schülerin!',
            'en': 'Surprise: Inspiring pupil!'
        },
        title: {
            'de': 'Maanasa Mendu,\nSchülerin und Jungforscherin',
            'en': 'Maanasa Mendu,\nPupil und Junior scientist'
        },
        content: {
            'de': 'Bei einem Familienbesuch in Indien sah die in den USA aufgewachsene Maanasa, wie schlecht die Energieversorgung im Heimatort ihrer Eltern war. Oft kam es dort zu Stromausfällen.\n\nAls Schülerin entwickelte sie deshalb ihr eigenes Energiegerät mit dem Namen ,Leaf‘. Das Gerät gewinnt Energie aus Sonne, Wind und Regen.\n\nSie arbeitet weiter an der Verbesserung ihres Geräts, hat damit aber auch schon Forschungspreise für Schülerinnen und Schüler gewonnen.',
            'en': 'On a family visit in India, Manasa, whos has been raised in the United States of America, how bad the power supply was in the home village of her parents. There where often power blackouts.\n\n While still being a pupil she developed the power machine called \'leaf\'. That machine produces electricity from the sun, wind and rain.\n\n She continues working an improving the machine and has won several science awards for pupils.'
        }
    },
    {
        week: 3,
        day: 5,
        type: 'text',
        status: {
            'de': 'Überraschung: Zitat!',
            'en': 'Surprise: Quotation!'
        },
        title: {
            'de': 'Jane Goodall,\nVerhaltensforscherin und Tierrechtaktivistin',
            'en': 'Jane Goodall,\nBehavioural scientist and animal rights activist'
        },
        quote: {
            'de': '„Du kannst etwas verändern –\njeden Tag und zu jeder Zeit!“',
            'en': '\'You can change something -\nevery day at every time!\''
        },
        copyright: {
            'de': 'Bild: Von Nick Stepowyj at https://www.flickr.com/photos/nickstep/5407412315/, CC BY 2.0, https://commons.wikimedia.org/w/index.php?curid=13238971',
            'en': 'Image: Nick Stepowyj at https://www.flickr.com/photos/nickstep/5407412315/, CC BY 2.0, https://commons.wikimedia.org/w/index.php?curid=13238971'
        }
    },
    {
        week: 4,
        day: 1,
        type: 'stars',
        status: {
            'de': 'Überraschung: Sterne für dich!',
            'en': 'Surprise: Stars for you!'
        }
    },
    {
        week: 4,
        day: 2,
        type: 'text',
        status: {
            'de': 'Überraschung: Hast du das gewusst?',
            'en': 'Surprise: Did you know?'
        },
        content: {
            'de': 'Eine britische Studie zeigt: Fast Food (also Schnellgerichte) schaden dem Gehirn.\n\nWer zehn Tage lang nur Fast Food wie Hamburger, Chips oder Pommes Frites isst, hat danach ein schlechteres Kurzzeitgedächtnis.\n\nDurch ausgewogene Ernährung kann die normale Gehirnkapazität wieder hergestellt werden.',
            'en': 'A british study shows: Junk food harms the brain.\n\n If you eat junk food - like hamburgers, crips and chips - for 10 days in a row, has a worse short term memory.\n\n With a blanced diet the brain capacity can be restored again.'
        }
    },
    {
        week: 4,
        day: 3,
        type: 'text',
        status: {
            'de': 'Überraschung: Zitat!',
            'en': 'Surprise: Quotation!'
        },
        title: {
            'de': 'Stephanie Kwolek,\nChemikerin, Erfinderin der Kunstfaser Kevlar',
            'en': 'Stephanie Kwolek,\nChemist, Inventor of the synthetic fiber Kevlar'
        },
        quote: {
            'de': '„Wenn du offen für neue Ideen bist und mit den Dingen herumspielst, kann alles passieren.“',
            'en': 'When you are open for new ideas and play around with things, everything can happen.'
        },
        copyright: {
            'de': 'Bild: Von Science History Institute, CC BY-SA 3.0, https://commons.wikimedia.org/w/index.php?curid=28982634',
            'en': 'Image: Science History Institute, CC BY-SA 3.0, https://commons.wikimedia.org/w/index.php?curid=28982634'
        }
    },
    {
        week: 4,
        day: 4,
        type: 'text',
        status: {
            'de': 'Überraschung: Inspirierende Sportlerin!',
            'en': 'Surprise: Inspiring athlete'
        },
        title: {
            'de': 'Julia Dujmovits,\nOlympiasiegerin im Snowboarden',
            'en': 'Julia Dujmovits,\nOlympia winner in snowboarding'
        },
        content: {
            'de': 'Julia Dujmovits ist ein Vorbild dafür, wie Visionen und Träume Wirklichkeit werden können, wenn man an seine inneren Stärken glaubt. Sie interessiert sich für Sport, Natur, Yoga, Mode, Kunst und Menschen. Ihre Gedanken und Ideen haben viele Menschen inspiriert.\n\nBereits im Alter von elf Jahren hatte das junge Mädchen aus dem Burgenland davon geträumt, bei den Olympischen Spielen eine Goldmedaille zu gewinnen. Nach vielen schmerzhaften Rückschlägen erreichte sie ihr Lebensziel. Bei den Olympischen Winterspielen 2014 in Japan wurde Julia Dujmovits Olympiasiegerin im Snowboarden.',
            'en': 'Julia Dujmovits is a role model for letting your dreams and visions come true by believing into your own strength.\n\n Sie is interested in sports, nature, yoga, fashion, art and humans. Her thoughts and ideas inspired many people.\n\n At the age of 11 the girl from Burgenland had the dream to win the gold medal at the olympic games. After many painful setbacks, she reached her goal. At the olympic winter games 2014 in Japan Julia Dujmovits became olympic winner in snowboarding'
        },
        copyright: {
            'de': 'Bild: Von Manfred Werner / Tsui - Eigenes Werk, CC BY-SA 3.0, https://commons.wikimedia.org/w/index.php?curid=28562320',
            'en': 'Image: Manfred Werner / Tsui - Eigenes Werk, CC BY-SA 3.0, https://commons.wikimedia.org/w/index.php?curid=28562320'
        }
    },
    {
        week: 4,
        day: 5,
        type: 'text',
        status: {
            'de': 'Überraschung: Inspirierende Produktdesignerin!',
            'en': 'Surprise: Inspiring product designer'
        },
        title: {
            'de': 'Dani Clode,\nProduktdesignerin ',
            'en': 'Dani Clode,\nProduct designer'
        },
        content: {
            'de': 'Dani Clode ist eine Produktdesignerin aus Neuseeland.\n\nMit ihrer preisgekrönten Arbeit „Der dritte Daumen“ zeigt sie, dass Prothesen nicht unbedingt das fehlende Körperteil abbilden müssen – sie können auch ganz neue Möglichkeiten eröffnen, wie zum Beispiel einen dritten Daumen. Bei diesem Projekt arbeitet sie insbesonders mit Gehirn-Wissenschaftlerinnen und -Wissenschaftlern zusammen.\n\nDani arbeitet daran, die Wahrnehmung und die Grenzen von Prothesen zu erforschen. Sie setzt dabei auch neue Materialien und Produktionsmethoden ein.',
            'en': 'DAni CLode is a product designer for New Zealand.\n\n With her award-winning work \'The third thumb\' she showed that prostheses must not necessarily substitude a missing body part – thay can also open up new possibilities, like for example a third thumb. For this project she was mainly working together with nero scientists.\n\n Dani is working on the perception and boundaries of prosthesis. For this she uses new materils and production methodes.'
        }
    }
];
